import React, { useEffect, useState } from 'react';
import { StickyNote, Loader2, Check } from 'lucide-react';

export function ContactNotes({ contact, onSave }) {
  const [text, setText] = useState(contact.notes || '');
  const [state, setState] = useState('idle');

  useEffect(() => { setText(contact.notes || ''); }, [contact.notes]);

  const dirty = text !== (contact.notes || '');

  const save = async () => {
    setState('saving');
    try {
      await onSave(contact.id, text);
      setState('saved');
      setTimeout(() => setState('idle'), 2000);
    } catch {
      setState('error');
    }
  };

  return (
    <div className="mt-4 rounded-xl border border-dashed border-[#E0A72C]/60 bg-[#FFFBEB] p-4" data-testid="contact-notes">
      <div className="flex items-center justify-between gap-3">
        <label className="inline-flex items-center gap-2 text-xs uppercase tracking-wider font-bold text-[#92400E]">
          <StickyNote className="w-4 h-4" /> Interne Notizen <span className="font-normal normal-case tracking-normal text-[#92400E]/70">(nur für dich sichtbar)</span>
        </label>
        <div className="flex items-center gap-2">
          {state === 'saved' && <span className="text-xs text-emerald-700 font-semibold inline-flex items-center gap-1" data-testid="notes-saved"><Check className="w-3.5 h-3.5" /> Gespeichert</span>}
          {state === 'error' && <span className="text-xs text-red-700 font-semibold" data-testid="notes-error">Fehler beim Speichern</span>}
          <button onClick={save} disabled={!dirty || state === 'saving'} className="h-8 px-3 rounded-md bg-[#0B1E44] text-white text-xs font-semibold inline-flex items-center gap-1.5 disabled:opacity-40 transition-opacity" data-testid="notes-save">
            {state === 'saving' ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Check className="w-3.5 h-3.5" />} Speichern
          </button>
        </div>
      </div>
      <textarea
        value={text}
        onChange={(e) => setText(e.target.value)}
        rows={text ? Math.min(8, Math.max(2, text.split('\n').length)) : 2}
        placeholder="z. B. Angebot 1.250 € gesendet · Besichtigung Di 14 Uhr · Kunde möchte Rückruf abends …"
        className="mt-3 w-full px-3 py-2.5 rounded-lg bg-white border border-[#E0A72C]/40 focus:border-[#B8892A] focus:ring-2 focus:ring-[#E0A72C]/30 outline-none text-sm text-[#0B1E44] leading-relaxed"
        data-testid="notes-textarea"
      />
    </div>
  );
}
